export default {
  baseStyle: {
    container: {
      position: 'relative',
    },
    inputContainer: {
      height: 13,
      alignItems: 'center',
      gap: {base: 4, md: 8},
      pb: 4,
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: {base: 5.25, md: 9},
      height: {base: 5.25, md: 9},
      flexShrink: 0,
      sx: {
        ' svg': {
          width: '100%',
          height: '100%',
        },
      },
    },
    input: {
      fontSize: {base: 'lg', md: '28px'},
      fontWeight: 'normal',
      color: 'brandColors.primaryText',
      lineHeight: 'normal',
      border: 'none',
      borderRadius: '0',
      background: 'transparent',
      px: 0,
      py: 0,
      height: 9,
      _placeholder: {
        color: 'blackAlpha.450',
      },
      _focus: {
        boxShadow: 'none',
        borderColor: 'transparent',
      },
      _hover: {
        borderColor: 'transparent',
      },
    },
    clearButton: {
      variant: 'ghost',
      size: 'sm',
      color: 'brandColors.primaryDarkLinen',
      fontSize: {base: '2xs', md: 'xs'},
      fontWeight: 'medium',
      lineHeight: 'normal',
      letterSpacing: {base: '2px', md: '2.4px'},
      textTransform: 'uppercase',
      px: 0,
      height: 'auto',
      minW: 'auto',
      _hover: {
        bg: 'transparent',
      },
    },
    divider: {
      borderTop: '1px solid black',
      mt: 0,
    },
    submitButton: {
      variant: 'ghost',
      w: {base: 6, md: 9},
      h: {base: 6, md: 9},
      minW: 'auto',
      color: 'brandColors.primaryDarkLinen',
      p: 0,
      _hover: {
        bg: 'transparent',
      },
      sx: {
        ' svg': {
          width: '100%',
          height: '100%',
        },
      },
    },
  },
  parts: [
    'container',
    'inputContainer',
    'iconWrapper',
    'input',
    'clearButton',
    'divider',
    'submitButton'
  ],
};
